import React from 'react';
import { Provider } from 'react-redux';
import { WebApi, WebApiProvider } from 'ascendon-web-api';
import './i18n';
import { render } from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { ConnectedRouter } from 'connected-react-router';
import './styles/index.scss';
import App from './app';
import buildStore from './configureStore';
import history from './utils/history';
import WebFont from 'webfontloader';
import { v4 as uuidv4 } from 'uuid';
import { LoggerController } from 'ascendon-web-toolkit/logs';
import { LocalStorage } from 'ascendon-web-toolkit/utils';

const initialState = {};
const contextId = uuidv4();
const store = buildStore(initialState, history);
const logger = new LoggerController({
  contextId,
  projectConfig: ASCENDON_ENV_CONFIG,
  application: 'FormulaOne Website',
  disable:
    window.ASCENDON_ENV_CONFIG.environment === 'prd1' ||
    window.ASCENDON_ENV_CONFIG.environment === 'stg1'
      ? true
      : false,
});
const webapi = new WebApi(store, {
  metadataUrl: ASCENDON_ENV_CONFIG.metadataUrl,
  apiUrl: ASCENDON_ENV_CONFIG.apiUrl,
  systemId: ASCENDON_ENV_CONFIG.systemId,
  channelId: ASCENDON_ENV_CONFIG.channelId,
  deviceType: ASCENDON_ENV_CONFIG['CD-DeviceType'],
  country: ASCENDON_APP_CONFIG.country,
  language: ASCENDON_APP_CONFIG.language,
});

LocalStorage.set('contextId', contextId);

const MOUNT_NODE = document.getElementById('ascendon');

// Used to prevent fonts from flickering when first loading
const fontsLoadedPromise = new Promise((resolve) => {
  const fonts = ['Adelle Sans', 'Adelle'];
  if (fonts.length) {
    const WebFontConfig = {
      classes: false,
      custom: {
        families: [],
      },
      active() {
        // All fonts have sucessfully preloaded...
        console.info('[FONTS] All fonts sucessfully loaded');
        resolve();
      },
      fontinactive(familyName) {
        // Log which specific fonts have failed to load.
        console.log(`[ERROR] Failed to load specific font: ${familyName}`);
      },
      inactive() {
        // All fonts have failed to preload
        // Let's not block the app from rendering but log an error
        console.log('[ERROR] Failed to load all fonts');
        resolve();
      },
    };
    WebFont.load(WebFontConfig);
  } else {
    console.info('[FONTS] No web fonts found');
    resolve();
  }
});

const renderApplication = (store, webapi) => {
  render(
    <Provider store={store}>
      <WebApiProvider webapi={webapi}>
        <BrowserRouter basename={ASCENDON_ENV_CONFIG.basename}>
          <ConnectedRouter history={history}>
            <App logger={logger} />
          </ConnectedRouter>
        </BrowserRouter>
      </WebApiProvider>
    </Provider>,
    MOUNT_NODE,
  );
};

fontsLoadedPromise.then(() => {
  renderApplication(store, webapi);
});
